module.exports = __webpack_public_path__ + "img/9-oneImg.f8bf5351.png";